import type { ReactNode } from 'react';

export const symbol_stethoscope_check: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m673-142-99-99q-9-9-9-21t9-21q9-9 21-9t21 9l78 77 163-162q9-9 21-8.5t21 9.5q9 9 9 21t-9 21L715-142q-9 9-21 9t-21-9ZM540-81q-109 0-184.5-78T280-347v-35q-85-11-142.5-75.5T80-610v-200q0-13 8.5-21.5T110-840h90v-10q0-13 8.5-21.5T230-880q13 0 21.5 8.5T260-850v80q0 12-8.5 21t-21.5 9q-13 0-21.5-8.5T200-770v-10h-60v170q0 71 49.5 120.5T310-440q71 0 120.5-49.5T480-610v-170h-60v10q0 12-8.5 21t-21.5 9q-13 0-21.5-8.5T360-770v-80q0-13 8.5-21.5T390-880q13 0 21.5 8.5T420-850v10h90q13 0 21.5 8.5T540-810v200q0 88-57.5 152.5T340-382v35q0 85 57.5 145.5T540-141q13 0 21.5 8.5T570-111q0 13-8.5 21.5T540-81Z"
		/>
	</svg>
);
